import { render } from "./AppGeneral.vue?vue&type=template&id=c5248608"
import script from "./AppGeneral.vue?vue&type=script&lang=js"
export * from "./AppGeneral.vue?vue&type=script&lang=js"

import "./AppGeneral.vue?vue&type=style&index=0&id=c5248608&lang=scss"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__